import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { PipesModule } from "@skills-app/shared/pipes/pipes.module";
import { ProfilePhotoModule } from "@skills-app/shared/components/profile-photo/profile-photo.module";
import { SkillChipListModule } from "@skills-app/shared/components/skill-chip-list/skill-chip-list.module";
import { TeamToggleButtonModule } from "@skills-app/shared/containers/team-toggle-button/team-toggle-button.module";
import { ProfileCompletenessIndicatorModule } from "@skills-app/shared/components/profile-completeness-indicator/profile-completeness-indicator.module";
import { ProfilePrimaryCapabilityBadgeModule } from "@skills-app/shared/components/profile-primary-capability-badge/profile-primary-capability-badge.module";

import { ConsultantCardComponent } from "./consultant-card.component";

@NgModule({
  declarations: [ConsultantCardComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,

    PipesModule,
    ProfilePhotoModule,
    SkillChipListModule,
    TeamToggleButtonModule,
    ProfileCompletenessIndicatorModule,
    ProfilePrimaryCapabilityBadgeModule,
  ],
  exports: [ConsultantCardComponent],
})
export class ConsultantCardModule {}
